const NFSeNatures = () => import('./pages/natures/NFSeNatures.vue');
const NFSeNaturesRegister = () => import('./pages/natures/NFSeNaturesRegister.vue');
const NFSeConfigurations = () => import('./pages/configurations/NFSeConfigurations.vue');
const NFSe = () => import('./pages/nfse/pages/NFSe.vue');
const NFSeForm = () => import('./pages/nfse/pages/NFSeForm.vue');
const ServiceTributes = () => import('./pages/tributes/ServiceTributes.vue');
const ServiceTributesRegister = () => import('./pages/tributes/ServiceTributesRegister.vue');

export default [
  {
    path: '/fiscal/nfse/natures',
    name: 'NFSeNatures',
    component: NFSeNatures,
    meta: {
      title: 'Naturezas',
    },
  },
  {
    path: '/fiscal/nfse/natures/new',
    name: 'NFSeNaturesRegister',
    component: NFSeNaturesRegister,
    meta: {
      title: 'Nova Natureza',
    },
  },
  {
    path: '/fiscal/nfse/natures/edit/:id',
    name: 'NFSeNaturesEdit',
    component: NFSeNaturesRegister,
    meta: {
      title: 'Editar Natureza',
    },
  },
  {
    path: '/fiscal/nfse/configurations',
    name: 'NFSeConfigurations',
    component: NFSeConfigurations,
    meta: {
      title: 'Configurações',
    },
  },
  {
    path: '/fiscal/nfse',
    name: 'NFSe',
    component: NFSe,
    meta: {
      title: 'NFS-e',
    },
  },
  {
    path: '/fiscal/nfse/new',
    name: 'NFSeRegister',
    component: NFSeForm,
    meta: {
      title: 'Nova NFS-e',
    },
  },
  {
    path: '/fiscal/nfse/edit/:id',
    name: 'NFSeEdit',
    component: NFSeForm,
    meta: {
      title: 'Editar NFS-e',
    },
  },
  {
    path: '/fiscal/nfse/tributes',
    name: 'ServiceTributes',
    component: ServiceTributes,
    meta: {
      title: 'Tributações',
    },
  },
  {
    path: '/fiscal/nfse/tributes/new',
    name: 'ServiceTributesRegister',
    component: ServiceTributesRegister,
    meta: {
      title: 'Nova Tributação',
    },
  },
  {
    path: '/fiscal/nfse/tributes/edit/:id',
    name: 'ServiceTributesRegister',
    component: ServiceTributesRegister,
    meta: {
      title: 'Editar Tributação',
    },
  },
];
